import { render } from "./Show.vue?vue&type=template&id=7d52d279&scoped=true"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=7d52d279&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d52d279"

export default script